<template>
    <section :key="componentKey">
        <vs-popup fullscreen classContent="popup-example" title="Video Player" :active.sync="moviePopUp">
            <div class="vx-row mb-q">
                <div class="vx-col w-full">
                    <center>
                        <video controls="" autoplay="" name="media">
                            <source :src="movie" type="video/mp4">
                            </video>
                        <br /><br />
                        <a :href="movie" target="_blank">Movie link</a>
                    </center>
                </div>
            </div>
        </vs-popup>
        <vs-popup classContent="popup-example" title="Remove Affiliate" :active.sync="popupRemoveAffiliate">
       
        <div class="vx-row mb-6">
            <div class="vx-col w-full">
            <vs-button @click="sendData('remove-affiliate')" color="primary" type="filled">Remove</vs-button>
            </div>
        </div>
        </vs-popup>
        <vs-popup classContent="popup-example" title="Table setup" :active.sync="popupActive">
            <div class="vx-row mb-4">
                <div class="vx-col w-1/4" v-for="(column,index) in columnDefs" :key="index" style="padding: 5px">
                    <vs-button class="ml-auto w-full" color="primary" :type="getType(column.field)" @click="showHideColumn(column.field)">{{column.headerName}}</vs-button> 
                </div>
            </div>
        </vs-popup>
        <vs-popup classContent="popup-example" title="Assign Agent" :active.sync="popupAssignAgent">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                Agent
                <v-select v-model="params.agent_name" label="agent" :options="agents" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                <vs-button @click="sendData('assign-agent')" color="primary" type="filled">Assign</vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup classContent="popup-example" title="Bank Options" :active.sync="popupBankBrokerOptions">
           
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                <vs-button @click="sendData('remove-bank-broker')" color="primary" type="filled">Remove</vs-button>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                <vs-input
                  class="inputx w-full bank_commi_box"
                  v-model="currentBank.commission"
                  placeholder="Enter commission as percent(0-100)"
              />
                <vs-button @click="sendData('commission-bank-broker')" color="primary" type="filled">Update Commission</vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup classContent="popup-example" title="PSP Options" :active.sync="popupPspBrokerOptions">
           
           <div class="vx-row mb-6">
               <div class="vx-col w-full">
               <vs-button @click="sendData('remove-psp-broker')" color="primary" type="filled">Remove</vs-button>
               </div>
           </div>
           <div class="vx-row mb-6">
               <div class="vx-col w-full">
               <vs-input
                 class="inputx w-full bank_commi_box"
                 v-model="currentPsp.commission"
                 placeholder="Enter commission as percent(0-100)"
             />
               <vs-button @click="sendData('commission-psp-broker')" color="primary" type="filled">Update Commission</vs-button>
               </div>
           </div>
       </vs-popup>

        <vs-popup classContent="popup-example" title="Remove Bank" :active.sync="popupRemoveBank">
           
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                <vs-button @click="sendData('remove-bank')" color="primary" type="filled">Remove</vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup classContent="popup-example" title="Remove Bank" :active.sync="popupRemoveBrokerBank">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    Banks
                    <v-select v-model="selectedBanks" label="bank" :options="bank" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateParams" />
                </div>
            </div>
           <div class="vx-row mb-6">
               <div class="vx-col w-full">
               <vs-button @click="sendData('remove-bank-broker')" color="primary" type="filled">Remove</vs-button>
               </div>
           </div>
       </vs-popup>
       <vs-popup classContent="popup-example" title="Add Bank" :active.sync="popupAddBrokerBank">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    Banks
                    <v-select v-model="selectedBanks" label="bank" :options="bank" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateParams" />
                </div>
            </div>
            <div class="vx-row mb-6" v-for="(bankDetail, index) in selectedBankDetails" :key="index">
                <div class="vx-col w-full">
                    <div>{{`${bankDetail.bank.bankName} ${bankDetail.bank.iban} ${bankDetail.bank.currency}` }}</div>
                        <vs-input
                            class="inputx w-full"
                            v-model="bankDetail.commission"
                            placeholder="Enter commission as percent(0-100)"
                        />
                    </div>
                </div>
                
           <div class="vx-row mb-6">
               <div class="vx-col w-full">
               <vs-button @click="sendData('add-bank-broker')" color="primary" type="filled">Add</vs-button>
               </div>
           </div>
       </vs-popup>
       <vs-popup classContent="popup-example" title="Remove PSP" :active.sync="popupRemoveBrokerPsp">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    PSP
                    <v-select v-model="selectedPsps" label="psp" :options="psp" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateParams" />
                </div>
            </div>
           <div class="vx-row mb-6">
               <div class="vx-col w-full">
               <vs-button @click="sendData('remove-psp-broker')" color="primary" type="filled">Remove</vs-button>
               </div>
           </div>
       </vs-popup>
       <vs-popup classContent="popup-example" title="Add PSP" :active.sync="popupAddBrokerPsp">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    PSP
                    <v-select v-model="selectedPsps" label="psp" :options="psp" multiple :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="updateParams" />
                </div>
            </div>
            <div class="vx-row mb-6" v-for="(pspDetail, index) in selectedPspDetails" :key="index">
                <div class="vx-col w-full">
                    <div>{{`${pspDetail.psp.display}` }}</div>
                        <vs-input
                            class="inputx w-full"
                            v-model="pspDetail.commission"
                            placeholder="Enter commission as percent(0-100)"
                        />
                    </div>
                </div>
                
           <div class="vx-row mb-6">
               <div class="vx-col w-full">
               <vs-button @click="sendData('add-psp-broker')" color="primary" type="filled">Add</vs-button>
               </div>
           </div>
       </vs-popup>
        <div class="vx-col w-full mb-base" v-if="filters.disable!==true">
        <vx-card title="Filter">
            <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full mb-2" v-if="filters.brokers && canSee('brokers')">
                    <vs-select
                        placeholder="Select brokers"
                        multiple
                        autocomplete
                        class="selectExample mb-2"
                        label="Brokers"
                        v-model="filterFields.brokers"
                        >
                        <vs-select-item :key="index" :value="item.bk_name" :text="item.bk_name" v-for="(item,index) in brokers" />
                    </vs-select>
                </div>
                <div class="vx-col sm:w-1/4 w-full mb-2" v-if="filters.status && canSee('status')">
                    <vs-select
                        placeholder="Select status"
                        multiple
                        autocomplete
                        class="selectExample mb-2"
                        label="Status"
                        v-model="filterFields.status"
                        >
                        <vs-select-item :key="index" :value="item.st_name" :text="item.st_name" v-for="(item,index) in status" />
                    </vs-select>
                </div>
                <div class="vx-col sm:w-1/4 w-full mb-2" v-if="filters.export && canSee('export')">
                   <!--button here-->
                </div>
                <div class="vx-col sm:w-1/4 w-full mb-2" v-if="filters.country && canSee('country')">
                    <vs-select
                        placeholder="Select Country"
                        multiple
                        autocomplete
                        class="selectExample mb-2"
                        label="Country"
                        v-model="filterFields.country"
                        >
                        <vs-select-item :key="index" :value="item.cl_Country" :text="item.cl_Country" v-for="(item,index) in country" />
                    </vs-select>
                </div>
                <div class="vx-col sm:w-1/4 w-full mb-2" v-if="filters.ver_status && canSee('ver_status')">
                    <vs-select
                        placeholder="Select ver status"
                        multiple
                        autocomplete
                        class="selectExample mb-2"
                        label="Ver Status"
                        v-model="filterFields.status"
                        >
                        <vs-select-item :key="index" :value="item.status_name" :text="item.status_name" v-for="(item,index) in ver_status" />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row"> 
                <div class="vx-col sm:w-1/4 w-full mb-2">
                    <div class="mt-5">
                        created at
                        <div>
                            <flat-pickr :config="configFromdateTimePicker" v-model="dateRange" placeholder="Select range" @on-change="onRangeChange" ref="programaticOpen"/>
                            <vs-button class="mb-4"  color="dark" type="border" @click="resetDate" data-clear>All time</vs-button>	
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full mb-2">
                    <div class="mt-5">
                        &nbsp;
                        <div>
                    <vs-button class="mr-3 mb-2" @click="setData">Submit</vs-button>
                        </div>
                    </div>
                </div>
            </div>	
        </vx-card>
    </div>
    <div>
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">

                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ tableData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : tableData.length }} of {{ tableData.length }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>

                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                        <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                        <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                        <span>100</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                        <span>150</span>
                    </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                    <vs-button type="line" color="primary" icon-pack="feather" icon="icon-settings" @click="popupActive=true"></vs-button>
                    <vs-button v-if="hasButtons('updateDoc')" color="danger" type="border" class="mr-3 mb-2" @click="popUps.updateDoc=true">Insert income</vs-button>
                    <vs-button v-if="hasButtons('updateDoc')" color="warning" type="border" class="mr-3 mb-2" @click="popUps.updateDoc=true">insert expense</vs-button>
                    <vs-button v-if="hasButtons('showDod')" color="danger" type="border" class="mr-3 mb-2" @click="goTo('/dod')">Show dod</vs-button>
                    <vs-button v-if="hasButtons('download')" color="warning" type="border" class="mr-3 mb-2" @click="download()">Download</vs-button>
                    
                    <vs-button v-if="hasButtons('addForm')" type="line" color="success" icon-pack="feather" icon="icon-plus" @click="popUps.popupAddActive=true"></vs-button>
                    <vs-button v-if="hasButtons('assign_agent')" color="warning" type="border" class="mr-3 mb-2" @click="popupAssignAgent=true">Assign</vs-button>
                    <vs-button v-if="isWireDetails" color="warning" type="border" class="mr-3 mb-2" @click="popupRemoveBank=true">Remove</vs-button>
                    <vs-button v-if="isBrokers" color="warning" type="border" class="mr-3 mb-2" @click="popupRemoveBrokerBank=true">Remove Bank</vs-button>
                    <vs-button v-if="isBrokers" color="warning" type="border" class="mr-3 mb-2" @click="popupAddBrokerBank=true">Add Bank</vs-button>
                    <vs-button v-if="isBrokers" color="warning" type="border" class="mr-3 mb-2" @click="popupAddBrokerPsp=true">Add PSP</vs-button>
                    <vs-button v-if="isBrokers" color="warning" type="border" class="mr-3 mb-2" @click="popupRemoveBrokerPsp=true">Remove PSP</vs-button>
                    <vs-button v-if="isBrokers" color="warning" type="border" class="mr-3 mb-2" @click="popupRemoveAffiliate=true">Remove Affiliate</vs-button>
                </div>
            </div>
            <!-- @filterChanged="onFilterChanged"
                :pinned-bottom-row-data="pinnedBottomRowData" -->
                <button @click="onExportCsv">Export to CSV</button>
            <ag-grid-vue
                ref="agGridTable"
                :modules="modules"
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="tableData"
                rowSelection="multiple"
                :animateRows="true"
                @grid-ready="onGridReady"
                @cellClicked="onCellClicked"                
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true"
                :enableRtl="$vs.rtl">
            </ag-grid-vue>
            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage" />
            </vx-card>
        </div>
    </section>
</template>
<script>
import { AgGridVue } from "ag-grid-vue"
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Vue from 'vue';
import brokerBanks from '../pages/brokers/brokerBanks.vue';
import brokerpsp from '../pages/brokers/brokerpsp.vue';
import brokerLink from '../pages/brokers/brokerLink.vue';
import status from '../../resources/status.json';
import country from '../../resources/country.json';
import ver_status from '../../resources/ver_status.json';
import vSelect from 'vue-select';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import CustomPinnedRowRenderer from './customPinnedRowRendererVue.js';
import { EventBus } from '@/eventBus.js';
import { CsvExportModule }          from '@ag-grid-community/csv-export';

Vue.component('brokerBanks', brokerBanks); 
Vue.component('brokerpsp', brokerpsp);
Vue.component('brokerLink', brokerLink);

export default {
    props:['banksObject','componentKey','endPoint','columnDefs','filters','popUps','buttons','lineDetails','callParams','callUrl','formParams','pspsObject'],
    components: {
        AgGridVue,
        flatPickr,
        brokerBanks,
        brokerpsp,
        brokerLink,
        'v-select': vSelect,
        JSZipUtils
    },
    created() {
            EventBus.$on('bank-clicked', this.handleBankClicked);
            EventBus.$on('psp-clicked', this.handlePspClicked);
    },
  beforeDestroy() {
            // Clean up the event listener when the component is destroyed
            EventBus.$off('bank-clicked', this.handleBankClicked);
            EventBus.$off('psp-clicked', this.handlePspClicked);
        },
    data() {
        let today = new Date();
        today = today.getFullYear()+ "-" + (today.getMonth() + 1) + "-" + today.getDate();
        let data = {
            movie:null,
            moviePopUp:false,
            bank:[],
            selectedBankDetails:[],
            selectedPspDetails:[],
            selectedBanks:[],
            frameworkComponents: null,
            modules: [ClientSideRowModelModule,CsvExportModule ],
            filteredTableData: [],
            pinnedBottomRowData:null,
            popupActive: false,
            popupAssignAgent: false,
            popupRemoveBank: false,
			selectedPsps: [],			
			psp: [],
            popupRemoveBrokerBank: false,
            popupRemoveBrokerPsp: false,
            popupAddBrokerBank: false,
            popupAddBrokerPsp: false,
            popupRemoveAffiliate: false,
            popupBankBrokerOptions: false,
            popupPspBrokerOptions: false,
            currentBank: {},
            currentPsp: {},
            tableData: [],
            params: {},
            clickedBankObject: {},
            clickedPspObject: {},
            filterFields:{brokers:[],status:[],ver_status:[],country:[]},
            gridApi: null,
            searchQuery:'',
            isBrokers: false,
            isWireDetails: false,
            isTickets: false,
            maxPageNumbers: 7,
           
            filesCounter:0,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
            },
            configFromdateTimePicker: {
                minDate: null,
                maxDate: null,
                mode: "range",
            },
            fromDate: '1970-10-10',
            toDate: today,
            dateRange:null,
            brokers: this.$store.state.brokers,
            agents: this.$store.state.agents,
            filtersStore: this.$store.state.AppActiveUser.filters,
            status:status,
            country:country,
            ver_status:ver_status
        }
        
        let that = this;
        this.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
        data.gridOptions = {
            onCellDoubleClicked: function(event){ 
                switch(event.column.colDef.action){
                    case 'useremail':
                        that.goTo('clients/'+event.data.id+'/'+event.data.email);
                        break;
                    case 'token_id':
                        that.goTo('tokens/'+event.data.token_id);
                        break;
                    case 'username':
                        that.goTo('clients/'+event.data.id+'/'+event.data.username);
                        break;
                    case 'email':
                    case 'brokerId':
                        that.goTo('brokers/'+event.data.id);
                        break;
                    case 'ticketId':
                        that.goTo('tickets/'+event.data.ticket_id+'/'+event.data.status_name);
                        break;
                }
            },
            frameworkComponents: {
                brokerBanks: brokerBanks,
                brokerLink: brokerLink,
                brokerpsp: brokerpsp
            },
            onDragStopped: function(){ that.saveState(); }
        }
        return data;
    },
    methods: {
        updateParams() {
            console.log('hi1')
          // Filter the full bank objects based on the selected display values   
            this.selectedBankDetails = this.banksObject.filter(bank => 
                this.selectedBanks.includes(bank.display)
            ).map(bank => {
                return {
                    bank: bank,
                    commission: '' // Initialize commission as empty
                };
            });
            console.log('hi2')
            this.selectedPspDetails = this.pspsObject.filter(psp => 
                this.selectedPsps.includes(psp.display)
            ).map(psp => {
                return {
                    psp: psp,
                    commission: '' // Initialize commission as empty
                };
            });
        },
        
        onExportCsv() {
      // Calls Ag-Grid's exportDataAsCsv API
        this.gridApi.exportDataAsCsv({
            fileName: `export_${new Date().toISOString().slice(0,10)}.csv`
        });
        },
      
        handleBankClicked(bankObj) {
            //console.log( bankObj);
            this.clickedBankObject = bankObj
            this.popupBankBrokerOptions=true
            //console.log(this.selectedRow)
        // Your handling code here   
        },

        handlePspClicked(pspObj) {
            
            
            this.clickedPspObject = pspObj
            this.popupPspBrokerOptions=true
            //console.log(this.selectedRow)
        // Your handling code here   handlePspClicked
        },

        canSee: function(val){
            return this.filtersStore.indexOf(val)!==-1;
        },
        printNode: function(node) {
          this.filteredTableData.push(node.data);
        },
        onFilterChanged: function(){
          this.filteredTableData.splice(0);
          this.gridApi.forEachNodeAfterFilter(this.printNode);
          this.pinnedBottomRowData = this.createData('Bottom');
          this.frameworkComponents = {
            customPinnedRowRenderer: CustomPinnedRowRenderer,
          };
        },
        createData() {
          let result = [];
          let obj = {};
          let initial_amount = 0;
          const amountFields = ['initial_amount'];
          for(let i in this.filteredTableData){
            initial_amount += Number(this.filteredTableData[i].initial_amount.replace('EUR','').replace(' ','').replace('BTC',''));
          }
          for(let i in this.filteredTableData[0]){
            if(amountFields.indexOf(i)===-1)
              obj[this.filteredTableData[0][i]] = '';
            else
              obj.initial_amount = initial_amount;
          }
          //console.log('initial_amount',initial_amount);
          result.push(obj);
          return result;
        },
        hasButtons: function(btn){
            //console.log(this.buttons)
            if(this.buttons!==undefined && this.buttons[btn]!==undefined){
                
                return this.buttons[btn];
            }
           
            return  false;
        },
        goTo: function(where){
            window.open(location.origin+'/'+where, '_blank');
        },
        download: function(){
            let downloadList = this.gridApi.getSelectedRows();
            for (let i in downloadList) {
                let href = downloadList[i].document_path;
                this.getFileToZip(href);
            }
            let that = this;
            var x = setInterval(function(){
                if(that.filesCounter==0){
                    let zip = new JSZip();   
                    zip.generateAsync({ type: "blob" })
                    .then(function (content) {
                        // see FileSaver.js
                        saveAs(content, "docs.zip");
                    });
                }
                clearInterval(x);
            },500);
        },
        getFileToZip: function(filename){
            let that = this;
            this.filesCounter++;
            // loading a file and add it in a zip file
            let zip = new JSZip();
            JSZipUtils.getBinaryContent(''+filename, function (err, data) {
                if (err) {
                    throw err; // or handle the error
                }
                var nameArr = filename.split('/');
                zip.file(nameArr[nameArr.length-1], data, { binary: true });
                that.filesCounter--;
            });
        },
        onCellClicked: function(event){
            if(event.column.colDef.field==='token_id'){
                this.goTo('tokens/'+event.data.token_id);            
                return false;
            }
            
            if(event.column.colDef.field==='ticket_id'){
                this.goTo('tickets/'+event.data.ticket_id+'/status'); 
                return false;
            }
             //console.log(event.column.colDef.action)
            switch(event.column.colDef.action){
                case 'video':{
                    const ext = event.data.file_location.split('.');
                    if(ext.at(-1)==='mp4'){
                        this.movie = 'https://crm.evblock.com/docs/'+event.data.file_location
                        this.moviePopUp = true;                                   
                    } else{
                        this.goTo('/docs/'+event.value)
                    }
                    break;
                }
                case 'showUser':
                    this.$router.push('/settings/users/'+event.value).catch(() => {})
                    break;
                case 'updateDocName':
                    for(let i in event.data)
                        this.lineDetails[i] = event.data[i];
                    this.popUps.updateDocName = true;
                    break;                    
                case 'editDic':
                    this.popUps.popupAddActive = true;
                    this.$set(this.formParams,'placeholder',event.data.placeholder);
                    this.$set(this.formParams,'value_en',event.data.value_en);
                    this.$set(this.formParams,'value_ru',event.data.value_ru);
                    this.$set(this.formParams,'formType','edit');
                    break;
                case 'preview':
                    this.popUps.popupPreview = true;
                    this.$set(this.formParams,'name',event.data.name);
                    this.$set(this.formParams,'subject',event.data.subject);
                    this.$set(this.formParams,'body',event.data.body);
                    break;
                case 'confirmWallet':
                    this.$set(this.formParams,'cl_wallet',event.data.cl_wallet);
                    this.$set(this.formParams,'username',event.data.username);
                    this.$set(this.formParams,'amount',event.data.amount);
                    this.popUps.popupAddActive = true;
                    break;
                case 'editQuickPage':
                    this.popUps.popupAddActive = true;
                    this.$set(this.formParams,'pageName',event.data.pageName);
                    this.$set(this.formParams,'pageTitle',event.data.pageTitle);
                    this.$set(this.formParams,'pageDescription',event.data.pageDescription);
                    this.$set(this.formParams,'formType','edit');
                    break;
                case 'editPage':
                    this.$router.push('/content/blog/'+event.data.pageName).catch(() => {})
                    break;                    
                case 'updateDoc':
                    for(let i in event.data)
                        this.lineDetails[i] = event.data[i];
                    this.popUps.updateDoc = true;
                    break;
                case 'assign_agent':
                     
                    this.popupAssignAgent = true;
                break;
                case 'remove_bank':
                     
                    this.popupRemoveBank = true;
                case 'single_bank':
                    this.goTo('wire_details/'+event.data.ba_id)
                            
                break;
                case 'actionDoc':
                    for(let i in event.data)
                        this.lineDetails[i] = event.data[i];
                    this.popUps.updateActionDoc = true;
                    break;
                case 'transactionId':
                    this.goTo('transaction/'+event.data.id+'/'+event.data.username);
                    break;
                case 'clientId':
                    this.goTo('clients/'+event.data.id+'/'+event.data.email)
                    break;
                case 'link':
                    this.goTo('/docs/'+event.value)
                break;
                case 'copy_bank':
                case 'copy_aff_link':
                case 'copy_psp':
                    
                    return;
                break;
                default:
                    this.copyToClipBoard(event.value);
            }
        },
        onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.setData();
        this.loadState();
        },
        setDataParams: function(){
            let params = new URLSearchParams();
            params.append('action', this.endPoint);
           
            switch(this.endPoint){
                case 'brokers':
                    this.isBrokers = true;
                break;
                case 'tickets':
                    this.isTickets = true;
                break;
                case 'wire_detail_section':
                    this.isWireDetails=true;
                break;
                 
            }
           
            let data1 = '';
            for(let i in this.filterFields.brokers){
                data1 += '&broker-search[]='+this.filterFields.brokers[i];
            }
            for(let i in this.filterFields.status){
                data1 += '&status-search[]='+this.filterFields.status[i];
            }
            for(let i in this.filterFields.ver_status){
                data1 += '&ver_status-search[]='+this.filterFields.ver_status[i];
            }
            for(let i in this.filterFields.country){
                data1 += '&country-search[]='+this.filterFields.country[i];
            }
            params.append('filter', 'start='+this.fromDate+'&end='+this.toDate+data1);
            return params;
        },
        setData: function(){
            this.gridApi.showLoadingOverlay();
            let params = '';
            if(this.callParams===undefined)
                params = this.setDataParams();
            else
                params = this.callParams;
            let that = this;
            let url = '/api/table';
            if(this.callUrl!==undefined)
                url = this.callUrl
            axios.post(url,params)
            .then((response) => {
                that.tableData.splice(0);
                //console.log('response',response);
                //that.filteredTableData.splice(0);                                
                if(response.data.Data!==undefined){
                    for(let i in that.columnDefs){                        
                        if(response.data.Allowed.indexOf(that.columnDefs[i].field)===-1){
                            that.gridOptions.columnApi.setColumnVisible(that.columnDefs[i].headerName, false)
                        }
                    }
                    for(let i in response.data.Data){
                        let data = response.data.Data[i];
                        that.tableData.push(data);
                        //that.filteredTableData.push(data);
                    }
                } if(response.data.Table!==undefined){
                    for(let i in response.data.Table){
                        let data = response.data.Table[i];
                        that.tableData.push(data);
                        //that.filteredTableData.push(data);
                    }
                } else{
                    for(let i in response.data){
                        let data = JSON.parse(response.data[i].object);
                        that.tableData.push(data);
                        //that.filteredTableData.push(data);
                    }
                }
                /*that.pinnedBottomRowData = that.createData('Bottom');
                that.frameworkComponents = {
                  customPinnedRowRenderer: CustomPinnedRowRenderer,
                };*/
            })
            .catch(() => {  })
        },
        sendData: function(type){
         
        const orType = type;
        if(type === 'remove-bank-broker' || type === 'add-bank-broker' || type === 'commission-bank-broker'){
            type = 'affiliate-actions'
        }
        if(type === 'remove-psp-broker' || type === 'add-psp-broker' || type === 'commission-psp-broker'){
            type = 'psp-actions'
        }
        
            

         let that = this;
         const params = new URLSearchParams();
         params.append('type', type);
         switch(type){
          
           case 'assign-agent':
                //console.log(this.params.agent_name)
                params.append('agent', this.params.agent_name.agent);
                var list= this.gridApi.getSelectedRows();
                var ids = ''
               
                for (let i in list) {
                    ids += ','+list[i].ticket_id;
                }
                ids = ids.substring(1);
                params.append('tl_id', ids);
            break;
            case 'remove-affiliate':
                var list= this.gridApi.getSelectedRows();
                var ids = ''
                
                for (let i in list) {
                    ids += ','+list[i].id;
                }
                ids = ids.substring(1);
                params.append('tl_id', ids);
            break;
            case 'remove-bank':
                //console.log(this.params.agent_name)
                 
                var list= this.gridApi.getSelectedRows();
                var ids = ''
                
                for (let i in list) {
                    ids += ','+list[i].ba_id;
                }
                ids = ids.substring(1);
                params.append('tl_id', ids);
            break;
            case 'affiliate-actions':
            var list= this.gridApi.getSelectedRows();
                var ids = ''
                
                for (let i in list) {
                    ids += ','+list[i].id;
                }
                ids = ids.substring(1);
                params.append('tl_id', ids);
                let banksArray;
                console.log(this.selectedBankDetails);
               
                //console.log('hello ' + ids)
                if(!this.selectedBankDetails.length){
                    banksArray=[{
                        bankId: this.clickedBankObject.bankId,
                        commission: this.currentBank.commission
                    }]
                }
                else{
                     
                    
                    banksArray = this.selectedBankDetails.map(bankDetail => {
                        return {
                            bankId: bankDetail.bank.bankId,
                            commission: bankDetail.commission,
                            currency: bankDetail.bank.currency
                        };
                    });
                
                }

               
                params.append('banks',JSON.stringify(banksArray) )
                params.append('methodType','bank' )
                switch(orType){
                    case 'remove-bank-broker':
                        params.append('actionType','remove')
                    break;
                    case 'add-bank-broker':
                        params.append('actionType','add')
                    break;
                    case 'commission-bank-broker':
                        params.append('actionType','commission')
                    break;

                }
               
 
              
            break;
            case 'psp-actions':
            
            var list= this.gridApi.getSelectedRows();
                var ids = ''
                
                for (let i in list) {
                    ids += ','+list[i].id;
                }
                ids = ids.substring(1);
                params.append('tl_id', ids);
                let pspArray;
             
                //console.log('hello ' + ids)
                if(!this.selectedPspDetails.length){
                     
                    pspArray=[{
                        pspTlId: this.clickedPspObject.pspTlId,
                        commission: this.currentPsp.commission
                    }]
                    
                }
                else{
                   
                    pspArray = this.selectedPspDetails.map(pspDetail => {
                        return {
                            pspTlId: pspDetail.psp.pspTlId,
                            commission: pspDetail.commission,
                            
                        };
                    });
                
                }

               
                params.append('psps',JSON.stringify(pspArray) )
                params.append('methodType','psp' )

                switch(orType){
                    case 'remove-psp-broker':
                        params.append('actionType','remove')
                    break;
                    case 'add-psp-broker':
                        params.append('actionType','add')
                    break;
                    case 'commission-psp-broker':
                        params.append('actionType','commission')
                    break;

                }
               
 
              
            break;
            
            
            default:
                return false;

         }
         
         this.$vs.loading();
         axios.post("/api/banking",params)
         .then((data) => {
           that.$vs.loading.close();
           
           if(data.data[0].out1==='done!'){
            
             this.popupAssignAgent=false;
             this.popupRemoveBank=false;
             this.popupBankBrokerOptions=false;
             this.popupPspBrokerOptions=false;
             this.popupAddBrokerBank=false;
             this.popupAddBrokerPsp=false;
             this.popupRemoveBrokerPsp=false;
             this.popupRemoveBrokerBank=false;
             that.setData()
             that.openAlert('success','Success',data.data[0].out1);
           } else{
             that.openAlert('danger','Failed',data.data[0].out1);
           }
           })
         .catch((error) => { console.log('e',error); that.$vs.loading.close(); that.openAlert('danger','Failed'); })
       },
        saveState: function(){
            try{
                localStorage.setItem(this.endPoint+'ColState', JSON.stringify(this.gridColumnApi.getColumnState()));
                localStorage.setItem(this.endPoint+'SortState', JSON.stringify(this.gridApi.getSortModel()));
            } catch(e){ this.doNothing() }
        },
        doNothing: function(){
            return false;
        },
        loadState: function(){
            try{
                let colState = JSON.parse(localStorage.getItem(this.endPoint+'ColState'));
                let sortState = JSON.parse(localStorage.getItem(this.endPoint+'SortState'));
                if(colState!==null)
                this.gridColumnApi.setColumnState(colState);
                if(sortState!==null)
                this.gridApi.setSortModel(sortState);
            } catch(e){ this.doNothing() }
        },
        copyToClipBoard: function(value){
            let that = this;
            let text = value;
            let textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                if(document.execCommand('copy'))
                    that.openAlert('success','','copied to clipboard');
            } catch(e){
                this.doNothing()
                //console.log('Oops, unable to copy');
            } 
            document.body.removeChild(textArea);
        },
        openAlert(color,title,text) {
            let colorAlert = color;
            this.$vs.notify({
                title: title,
                text: text,
                color: colorAlert
            })
        },
        updateSearchQuery(val) {
          this.gridApi.setQuickFilter(val)
        },
        getType: function(name){
            if(this.gridColumnApi===undefined)
                return 'filled';
            let colState = this.gridColumnApi.getColumnState();
            for(let i in colState){
                if(colState[i].colId===name){
                return colState[i].hide === false ? 'filled' : 'border';
                }
            }
            return 'filled';
        },
        showHideColumn: function(name){
            let colState = this.gridColumnApi.getColumnState();
            let hideCol = false;
            for(let i in colState){
                if(colState[i].colId===name){
                hideCol = colState[i].hide;
                break;
                }
            }
            this.gridColumnApi.setColumnVisible(name, hideCol);
            this.saveState();
        },
        resetDate: function(){
            let today = new Date()
            today = today.getFullYear()+ "-" + (today.getMonth() + 1) + "-" + today.getDate()
            this.fromDate= '1970-10-10';
            this.toDate= today;
            this.dateRange=null;
        },
        onRangeChange(selectedDates, dateStr) {
            let range = dateStr.split(' to ');
            this.fromDate = range[0];
            this.toDate = range[1];
        },
        onFromChange(selectedDates, dateStr) {
            this.$set(this.configTodateTimePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr) {
            this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
        },
    },
    watch: {
        banksObject: {
            immediate: true,
            handler(newValue) {
                if(newValue && newValue.length){
                    this.bank = newValue.map(item => item.display);
                }
            }
        },
        pspsObject: {
            immediate: true,
            handler(newValue) {
                if(newValue && newValue.length){
                    this.psp = newValue.map(item => item.display);
                }
            }
        }
    },
    computed: {
        paginationPageSize() {
            if(this.gridApi) return this.gridApi.paginationGetPageSize()
            else return 50
        },
       
        totalPages() {
            if(this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        }
    },
    mounted() {
        //this.gridApi = this.gridOptions.api
        //this.gridColumnApi = this.gridOptions.columnApi;
        if(this.$vs.rtl) {
            const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
            header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
        }
      
        if(this.banksObject && this.banksObject.length){
            
             this.bank = this.banksObject.map(item => item.display);
   
        }

        if(this.pspsObject && this.pspsObject.length){
            
            this.psp = this.pspsObject.map(item => item.display);
  
       }
        
    }
}
</script>
<style scoped>
.media {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    max-height: 100%;
    max-width: 100%;
    margin: auto;
}
.bank_commi_box{
    margin-bottom: 20px;
    
}
</style>